import MessageModal from 'components/features/modal/MessageModal';
import React from 'react';

export const SNSErrorModal = ({
  hideModal,
  isShowModal,
}: {
  isShowModal: boolean;
  hideModal: () => void;
}): React.ReactElement => {
  return (
    <>
      {isShowModal && (
        <MessageModal
          message={[
            'サーバー上でエラーが発生したか、まだ利用可能ではありません。別のSNSをご利用ください。',
          ]}
          title="このSNSは利用できません"
          onClose={hideModal}
        />
      )}
    </>
  );
};
